<template>
  <t-config-provider :global-config="globalConfig">
    <qa-tree
      ref="qaTreeRef"
      :g-config="localGConfig"
      :init-json="initJson"
      @graphEvent="handlerGraphEvent"
    ></qa-tree>
  </t-config-provider>
</template>
<script lang="ts">
import QaTree from "./flow/QaTree.vue";
import { provide, Ref, ref } from "vue";
import { getNodeList } from "./main2";
import { defaultGlobalConfig, GraphConfig } from "./start";
import enLocale from "tdesign-vue-next/es/locale/en_US.mjs";
import zhLocale from "tdesign-vue-next/es/locale/zh_CN.mjs";
import { merge } from "lodash-es";
import "./reset.css";

interface Data {
  initJson: Ref<string>;
  fn?: (...args: any[]) => any;
  getGroups: Ref<() => Promise<Array<{ value: string; label: string }>>>;
  getTaskFlows: Ref<() => Promise<Array<{ value: string; label: string }>>>;
  getTaskTriggerEventIds: Ref<
    () => Promise<Array<{ value: string; label: string }>>
  >;
  uploadCos: Ref<(file: File) => Promise<string>>;
  maxLimits: Ref<{ maxAnswerLength: number }>;
  localGConfig: Ref<GraphConfig>;
}
export default {
  components: {
    QaTree,
  },
  props: {
    gConfig: {
      required: true,
      type: Object,
    },
    taskType: {
      required: true,
      type: String,
    },
  },
  setup(props): Data {
    const initJson = ref("{}");
    const getGroups = ref<any>();
    const getTaskFlows = ref<any>();
    const getTaskTriggerEventIds = ref<any>();
    const uploadCos = ref<any>();
    const maxLimits = ref<{ maxAnswerLength: number }>({
      maxAnswerLength: 2000,
    });

    provide("getGroups", getGroups);
    provide("getTaskFlows", getTaskFlows);
    provide("getTaskTriggerEventIds", getTaskTriggerEventIds);
    provide("uploadCos", uploadCos);
    provide("maxLimits", maxLimits);
    provide("taskType", props.taskType);

    const localGConfig = ref({ ...props.gConfig });

    return {
      initJson,
      fn: undefined,
      getGroups,
      getTaskFlows,
      getTaskTriggerEventIds,
      uploadCos,
      maxLimits,
      localGConfig,
    };
  },
  computed: {
    globalConfig() {
      return merge(
        this.$i18n.locale === "en" ? enLocale : zhLocale,
        defaultGlobalConfig,
      );
    },
  },
  methods: {
    /**
     * @description
     ** 向外暴露的 API ，添加事件功能
     */
    addEvent(fn: (...args: any[]) => any) {
      this.fn = fn;
    },
    addUploadEvent(fn) {
      this.uploadCos = fn;
      console.log("app uploadCos", this.uploadCos, fn);
    },
    addGetGroupsEvent(fn) {
      this.getGroups = fn;
    },
    addGetTasksEvent(fn) {
      this.getTaskFlows = fn;
    },
    addGetTaskTriggerEvent(fn) {
      this.getTaskTriggerEventIds = fn;
    },
    handlerGraphEvent({ type, payload }) {
      if (this.fn) {
        this.fn(type, payload);
      }
    },
    setMaxLimits(limits) {
      this.maxLimits = limits;
    },
    /**
     * @description 向外暴露的 API ，设置数据事件
     */
    readData(jsonData: string) {
      this.initJson = jsonData;
      const qaTreeRef = this.$refs.qaTreeRef as (typeof QaTree)["methods"];

      if (qaTreeRef) {
        qaTreeRef.draw(JSON.parse(jsonData));
      }
    },
    handleSave(params) {
      const qaTreeRef = this.$refs.qaTreeRef as (typeof QaTree)["methods"];
      if (qaTreeRef) {
        qaTreeRef.handlerSave(params);
      }
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      if (this.localGConfig.node) {
        this.localGConfig.node.nodeList = getNodeList(this.$props.taskType);
      }
      this.readData(this.initJson);
    },
  },
};
</script>
